"use client";

import { Award, Download, Shield, Sparkles, Syringe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const standards = [{
    icon: Shield,
    title: "Global Regulatory Compliance",
    description: "We ensure all imported medical devices meet stringent international standards, including CE, FDA, and ISO certifications, guaranteeing safety and efficacy."
  }, {
    icon: Syringe,
    title: "Clinical Evaluation Support",
    description: "Our team provides comprehensive clinical data analysis and evaluation reports to help healthcare professionals make informed, evidence-based procurement decisions."
  }, {
    icon: Sparkles,
    title: "Quality Assurance Protocols",
    description: "Every product undergoes rigorous quality checks and supply chain verification, ensuring that only premium, reliable technologies reach our distribution partners."
  }, {
    icon: Award,
    title: "Strategic Partnership Standards",
    description: "We maintain long-term, transparent relationships with global manufacturers, ensuring consistent supply chain integrity and post-market support for all our clients."
  }];
  const certifications = ["ISO 13485 CERTIFIED", "CE MARK COMPLIANT", "FDA REGISTERED", "GLOBAL QUALITY STANDARDS", "CLINICAL VALIDATION"];
  return <section data-section-id="32" id="complianceandcertifications" className="py-24 md:py-32 lg:py-40 px-6 md:px-10 font-default bg-background text-foreground">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs md:text-sm tracking-widest uppercase mb-8 text-blue-600">
            03 / COMPLIANCE & QUALITY
          </p>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-light leading-[0.95] tracking-tight">
            Global
            <br />
            <span className="italic text-teal-600">Standards.</span>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 relative">
          {standards.map((item, i) => {
          const Icon = item.icon;
          return <div data-index={i} key={i} className={`relative p-8 md:p-10 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i % 2 === 1 ? "sm:border-l" : ""} ${i >= 2 ? "sm:border-t lg:border-t-0" : ""} ${i > 0 ? "lg:border-l border-t sm:border-t-0" : ""}`} style={{
            transitionDelay: `${i * 120}ms`,
            borderColor: "var(--border)"
          }}>
                <Icon className="w-16 h-16 mb-8 text-blue-600" strokeWidth={1} />
                <h3 className="font-default text-2xl font-medium leading-tight mb-4">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed font-default text-muted-foreground">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 transition-all duration-700 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 mb-16 md:mb-20">
            {certifications.map((cert, i) => <span data-index={i} key={i} className="font-default text-xs tracking-widest uppercase text-muted-foreground">
                {cert}
              </span>)}
          </div>

          {}
          <div className="flex justify-center">
            <Button variant="outline" size="lg" className="font-default text-xs tracking-widest uppercase bg-transparent border-2 px-8 py-6 h-auto transition-colors duration-300 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg">
              <Download className="w-4 h-4" strokeWidth={1.5} />
              Download Compliance Dossier (PDF)
              <span aria-hidden="true">→</span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}